import * as React from 'react';
import { Popover as PopoverPrimitive } from 'radix-ui';

export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;

type PopoverContentProps = React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
  withinPortal?: boolean;
};

export const PopoverContent = React.forwardRef<HTMLDivElement, PopoverContentProps>(
  function PopoverContent({ className = '', sideOffset = 8, children, withinPortal = true, ...props }, ref) {
    const Content = (
      <PopoverPrimitive.Content
        data-component="Popover"
        data-package="@appic/ui-components"
        ref={ref}
        sideOffset={sideOffset}
        className={`z-60 rounded-md p-3 shadow-md outline-none border bg-elevated text-foreground border-border ${className}`}
        role="dialog"
        {...props}
      >
        {children}
        <PopoverPrimitive.Arrow className="fill-elevated" />
      </PopoverPrimitive.Content>
    );
    if (withinPortal) {
      return <PopoverPrimitive.Portal>{Content}</PopoverPrimitive.Portal>;
    }
    return Content;
  }
);